import gql from 'graphql-tag'

export const LOAD_BLOCK = gql`
    query loadBlock($blockID: ID!) {
        loadBlock(blockID: $blockID) {
            id
            identifier
            createdAt
            currentVersion {
                id
                name
                contents
                state
                updatedBy {
                    id
                    name
                }
                createdAt
                updatedAt
            }
            historyVersions {
                name
                id
                blockID
                state
                contents
                createdAt
                updatedAt
                updatedBy {
                    id
                    name
                }
            }
        }
    }
`
